import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './components/footer/footer.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NotFoundComponent } from './components/not-found/not-found.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule
  ],
  declarations: [
    FooterComponent,
    NotFoundComponent
  ],
  exports: [
    FooterComponent,
    NotFoundComponent
  ]
})
export class IsakayaSharedModule { }
